import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '사이트는 판매용인가요, 아니면 생산용인가요?',
      answer: '우리 플랫폼은 생산에 중점을 두고 설계되어 전 세계 사용자에게 강력하고 역동적인 도박 환경을 제공합니다. 판매용은 아니지만 파트너가 자신의 데이터에 무제한 적인 접근권한을 제공하여 독점적인 기능을 제한없이 사용이 가능합니다.'
    },
    {
      question: '레알타드의 사이트 준비 및 지원 범위는 어떻게 되나요?',
      answer: '사이트 운영에 필요한 컨텐츠와 계정만 준비 해 주시면 됩니다. 초기 사이트 컨셉부터 오픈까지 컨텐츠와 계정을 제외한 모든 부분은 레알타드가 준비합니다.'
    },
    {
      question: '제공되는 제품 범위는 어떻게 되나요?',
      answer: '스포츠북, 온라인카지노, 온라인슬롯, 버추어스포츠, 미니게임, 그래프게임, 한국결제시스템, 암호화폐 결제 시스템, 해외결제 시스템등 운영에 필요한 모든 부분이 제공 됩니다. 운영자 님들은 마케팅만 하시면 됩니다.'
    },
    {
      question: '기술적으로 믿을 수 있는 솔루션인가요?',
      answer: '레알타드는 플랫폼과 서비스의 경쟁력을 유지하기 위해 정기적으로 업데이트와 업그레이드를 제공합니다. 파트너를 위한 당사의 기술 지원은 플랫폼 통합부터 실시간 문제 해결까지 모든 것을 포괄하여 지원됩니다.'
    },
    {
      question: '가격은 어떻게 되나요?',
      answer: '레알타드는 정식 해외 업계 중 최고로 경쟁력 있는 가격을 제안합니다.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="animate-fade-in">
            <h6 className="text-teal-600 font-semibold mb-2">FAQ</h6>
            <h2 className="text-4xl font-bold text-gray-900 mb-8">자주 묻는 질문</h2>
            <img 
              src="https://winka.io/wp-content/uploads/2024/01/FAQ-2.webp" 
              alt="FAQ Illustration"
              className="w-full h-auto rounded-2xl"
            />
          </div>

          <div className="space-y-4 animate-fade-in-right">
            {faqs.map((faq, index) => (
              <div 
                key={index}
                className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
                >
                  <span className="font-semibold text-gray-900 pr-4">{faq.question}</span>
                  <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-teal-600 flex-shrink-0`}></i>
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-5 text-gray-600 leading-relaxed animate-fade-in">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
